var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"not-found",staticClass:"not-found",attrs:{"src":"https://www.partners.engineering.com/notfound"}})}
var staticRenderFns = []

export { render, staticRenderFns }